import React, {useEffect, useState} from 'react';
import { Layout, Row, Col } from 'antd';
import { Descriptions } from 'antd';
import axios from "axios";
import AxiosRequest from "../../helpers/AxiosRequest";
import MsgsTable from "../../components/msgsTable/MsgsTable";
import {Link} from "react-router-dom";
import DeleteMsg from "../../components/msgsTable/deleteMsg";
import RoomBan from "../../components/usersTable/roomBan";

const { Content } = Layout;

const SingleRoomPage = (props) => {

    const [room, setRoom] = useState({});
    const [admin, setAdmin] = useState({});
    const [adminData, setAdminData] = useState({
        name: 'noName'
    });
    const [msgs, setMsgs] = useState(null);
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'User name',
            dataIndex: 'user',
            key: 'userName',
            render: user => <Link to={{
                pathname: `/${props.match.params.imba_id}/user/${user.remote_user_id}`
            }}>{user.login!='NULL' ? user.login: user.remote_user_id}</Link>,
        },
        {
            title: 'Room name',
            dataIndex: 'room',
            key: 'roomName',
            render: room => <Link to={{
                pathname: `/${props.match.params.imba_id}/room/${room.id}`
            }}>{room.name}</Link>,
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'messageText',
            render: text => <p>{text}</p>
        },
        {
            title: 'Actions',
            key: 'actions',
            dataIndex: 'room',
            render: (text, record) => (
                <>
                    <DeleteMsg msg={record} imba_id={props.match.params.imba_id}/>
                    <RoomBan record={text} imba_id={props.match.params.imba_id}/>
                </>
                
            )
        }
    ];

    useEffect(() => {
        (async () => {

            AxiosRequest("imba_single_room", {
                id: props.match.params.id,
                imba_id: props.match.params.imba_id
            })
                .then((data) => {
                    setRoom(data)
                    setAdmin(data.admin)
                })
                .catch((error) =>{
                   // window.location.href = `#/${props.match.params.imba_id}/signIn`
                });
        })();
    }, []);

    useEffect(() => {
        if (room)
            if (room.id)
            {
                let params = {
                    room_id: room.id,
                    imba_id: props.match.params.imba_id
                }
                AxiosRequest('imba_msgs_get', params)
                    .then((response) => {
                        setMsgs(response.data)
                    })
            }
    }, [room])

    useEffect(() => {
        if (admin)
            if (admin.remote_user_id)
            {
                AxiosRequest("imba_single_user", {
                    id: admin.remote_user_id,
                    imba_id: props.match.params.imba_id
                })
                    .then((data) => {
                        if (data.api_info[0])
                            setAdminData(data.api_info[0])
                        else
                            setAdminData({
                                name: 'NoName',
                            })
                    })
                    .catch((error) =>{
                        //window.location.href = `#/${props.match.params.imba_id}/signIn`
                    });
            }
    }, [admin]);

    const RoomData = () => (
        <Descriptions title="Room Info" layout="vertical">
            <Descriptions.Item label="Room`s Name">{room.name}</Descriptions.Item>
            <Descriptions.Item label="Room`s Creator">{adminData.name}</Descriptions.Item>
        </Descriptions>
    )
    return(
        <div>
            <Content style={{ padding: '50px 150px' }}>
                <div className="site-layout-content">
                    <RoomData />
                </div>
            </Content>
            <div>
                <MsgsTable columns={columns} dataSource={msgs}/>
            </div>
        </div>
    )
}

export default SingleRoomPage;